import { Button } from "@/components/ui/button";
import { LogIn } from "lucide-react";
import { PORTAL_URL } from "@/lib/drivego";

/**
 * «Log ind» → DriveGo-kundeportalen, hvor kunden ser sine bookinger, tilbud
 * og fakturaer. Erstatter den tidligere Emergent/Google-login og «Mit område».
 */
const PortalButton = () => (
  <a href={PORTAL_URL} data-testid="login-portal-btn">
    <Button
      variant="outline"
      className="border-white/20 bg-transparent text-white hover:bg-white/10 hover:border-white/40 rounded-sm font-bold transition-colors"
    >
      <LogIn className="w-4 h-4 mr-2" /> Log ind
    </Button>
  </a>
);

export default PortalButton;
